import { makeObservable, observable, action } from 'mobx';
// eslint-disable-next-line import/no-cycle
import api from '../api';

class MatchedStore {
  matchedList = [];

  currentPage = 1;

  perPage = 10;

  pagesCount = 1;

  isLoading = true;

  constructor() {
    makeObservable(this, {
      matchedList: observable,
      currentPage: observable,
      perPage: observable,
      pagesCount: observable,
      isLoading: observable,
      fetchMatchedList: action,
    });
  }

  fetchMatchedList(reportId, page) {
    this.isLoading = true;
    return api.getMatchedList(reportId, page)
      .then((response) => {
        this.matchedList = response.response;
        this.currentPage = response.pagination.current;
        this.perPage = response.pagination.per_page;
        this.pagesCount = response.pagination.pages;
        this.isLoading = false;
      });
  }
}

export default MatchedStore;
